const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://mtg-app-backend-7c170e7e1298.herokuapp.com/api"
    : "http://localhost:5000/api";

export const aiQuery = async (naturalQuery) => {
  try {
    const res = await fetch(`${BASE_URL}/ai`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ prompt: naturalQuery }),
    });

    const data = await res.json();

    if (!res.ok) {
      throw new Error(data.error || "Unknown error");
    }

    return data.query; // Scryfall ready query string
  } catch (err) {
    console.error("AI query error:", err.message);
    return null;
  }
};
